<script lang="ts">
  import type { Media } from '@lib/types/media';
  import { onMount } from 'svelte';

  export let media: Media;
  export let className: string = '';
  export let playing: boolean | undefined = undefined;

  let Component: any = null;

  onMount(async () => {
    // Dynamic imports for tree-shaking
    switch (media.type) {
      case 'image':
        const { default: MediaImage } = await import('./MediaImage.svelte');
        Component = MediaImage;
        break;
      case 'video':
        const { default: MediaVideo } = await import('./MediaVideo.svelte');
        Component = MediaVideo;
        break;
      case 'gradient':
        const { default: MediaGradient } = await import('./MediaGradient.svelte');
        Component = MediaGradient;
        break;
      case 'pattern':
        const { default: MediaPattern } = await import('./MediaPattern.svelte');
        Component = MediaPattern;
        break;
    }
  });
</script>

{#if Component}
  <svelte:component this={Component} {media} {className} {playing} />
{:else}
  <div
    class="media-loading {className}"
    aria-label="Loading media..."
    style:aspect-ratio={media.type === 'image' && media.aspectRatio ? media.aspectRatio.replace(':', '/') : null}
  ></div>
{/if}

<style>
  .media-loading {
    width: 100%;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
  }

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
</style>